import React, { useState } from 'react';
import SEO from '../../../component/common/SEO';
import { pageSEO } from '../../../config/seoConfig';
import { SlLocationPin } from 'react-icons/sl';
import { GoMail } from 'react-icons/go';
import { IoCallOutline, IoCloudUploadOutline } from 'react-icons/io5';
import { ToastTypes, useMessage } from '../../../base/context/MessageProvider';
import { useLoader } from '../../../base/context/LoaderProvider';
import { ContactApiService } from '../../../service/website/contactApiService';
import { emailRegex } from '../../../helper/regex';
import './style.css';

const RegistrationFormCS = () => {
  const { showMessage } = useMessage();
  const { showLoader, hideLoader } = useLoader();

  const [formData, setFormData] = useState({
    personName: '',
    companyName: '',
    city: '',
    website: '',
    wechatId: '',
    mobileNumber: '',
    productCategory: '',
    catalogFile: null,
    distributorInterest: '',
    amazonSelling: '',
    authorizeImporterr: '',
  });

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === 'file' ? files[0] : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      showLoader();
      const payload = new FormData();
      Object.keys(formData).forEach((key) => {
        if (formData[key]) {
          payload.append(key, formData[key]);
        }
      });

      await ContactApiService.submitEnquiry(payload); 

      showMessage(ToastTypes.SUCCESS, 'Registration submitted successfully! / 注册提交成功！');
      
      setFormData({
        personName: '', companyName: '', city: '', website: '', wechatId: '',
        mobileNumber: '', productCategory: '', catalogFile: null, 
        distributorInterest: '', amazonSelling: '', authorizeImporterr: ''
      });
      
      document.getElementById('catalogFileInput').value = ""; 

    } catch (error) {
      showMessage(ToastTypes.ERROR, 'Failed to submit the form. Please try again. / 提交表单失败，请重试。');
      console.error("Form Submission Error:", error);
    } finally {
      hideLoader();
    }
  };

  return (
    <div className="page-wrapper-cs">
      <SEO {...pageSEO?.registration} /> 

      <div className="form-container-cs">
        {/* Header Section */}
        <div className="form-header-cs">
          <h1>Chinese Sellers – Registration Form / 中国卖家 – 注册表</h1>
          <p>Please fill out the details below to register. All fields marked with * are mandatory.<br/>
          请填写以下详细信息进行注册。标有 * 的字段为必填项。</p>
        </div>

        {/* Form Body */}
        <form onSubmit={handleSubmit} className="g-form-cs">
          
          <div className="form-group-cs">
            <label>Person Name / 联系人姓名 <span className="required-cs">*</span></label>
            <input type="text" name="personName" value={formData.personName} onChange={handleChange} placeholder="Your answer / 你的回答" required />
          </div>

          <div className="form-group-cs">
            <label>Company Name / 公司名称</label>
            <input type="text" name="companyName" value={formData.companyName} onChange={handleChange} placeholder="Your answer / 你的回答" required />
          </div>

          <div className="form-group-cs">
            <label>City / 城市 <span className="required-cs">*</span></label>
            <input type="text" name="city" value={formData.city} onChange={handleChange} placeholder="Your answer / 你的回答" required />
          </div>

          <div className="form-group-cs">
            <label>Website / 网站</label>
            <input type="text" name="website" value={formData.website} onChange={handleChange} placeholder="https://..." required />
          </div>

          <div className="form-group-cs">
            <label>WeChat ID / 微信号</label>
            <input type="text" name="wechatId" value={formData.wechatId} onChange={handleChange} placeholder="Your answer / 你的回答" required />
          </div>

          <div className="form-group-cs">
            <label>WhatsApp / Mobile Number / 手机号码 <span className="required-cs">*</span></label>
            <input type="tel" name="mobileNumber" value={formData.mobileNumber} onChange={handleChange} placeholder="Your answer / 你的回答" required />
          </div>

          <div className="form-group-cs">
            <label>Product Category / 产品类别 <span className="required-cs">*</span></label>
            <input type="text" name="productCategory" value={formData.productCategory} onChange={handleChange} placeholder="Your answer / 你的回答" required />
          </div>

          {/* Catalog File Upload */}
          <div className="form-group-cs">
            <label>Ecommerce Supportive Catalog / 支持电子商务的产品目录</label>
            <div className="file-upload-box-cs">
              <input type="file" name="catalogFile" id="catalogFileInput" accept=".pdf,.doc,.docx,.xls,.xlsx,image/*" onChange={handleChange} className="file-input-hidden-cs" />
              <label htmlFor="catalogFileInput" className="file-upload-label-cs">
                <IoCloudUploadOutline className="upload-icon-cs" />
                <span>
                  {formData.catalogFile 
                    ? `Selected / 已选择: ${formData.catalogFile.name}` 
                    : "Click to browse or drag catalog here / 点击浏览或将目录拖拽到此处"}
                </span>
              </label>
            </div>
          </div>

          <div className="form-group-cs radio-group-cs">
            <label>Are you interested in appointing a Distributor in India? / 您是否有兴趣在印度指定经销商？</label>
            <div className="radio-options-cs">
              <label>
                <input type="radio" name="distributorInterest" value="Yes" checked={formData.distributorInterest === 'Yes'} onChange={handleChange} required />
                Yes / 是
              </label>
              <label>
                <input type="radio" name="distributorInterest" value="No" checked={formData.distributorInterest === 'No'} onChange={handleChange} required />
                No / 否
              </label>
            </div>
          </div>

          <div className="form-group-cs">
            <label>Are you selling on amazon.com? (If yes, kindly share brand name) / 您是否在 amazon.com 上销售？（如果是，请分享品牌名称）</label>
            <input type="text" name="amazonSelling" value={formData.amazonSelling} onChange={handleChange} placeholder="e.g., No, or Yes (Brand: XYZ) / 例如，否，或 是（品牌：XYZ）" required />
          </div>

          <div className="form-group-cs radio-group-cs">
            <label>Are you ready to authorize importerr.com to sell your products online & offline in India? / 您是否准备授权 importerr.com 在印度线上和线下销售您的产品？</label>
            <div className="radio-options-cs">
              <label>
                <input type="radio" name="authorizeImporterr" value="Yes" checked={formData.authorizeImporterr === 'Yes'} onChange={handleChange} required />
                Yes / 是
              </label>
              <label>
                <input type="radio" name="authorizeImporterr" value="No" checked={formData.authorizeImporterr === 'No'} onChange={handleChange} required />
                No / 否
              </label>
            </div>
          </div>

          <div className="form-actions-cs">
            <button type="submit" className="submit-btn-cs">Submit Application / 提交申请</button>
            <button type="button" className="clear-btn-cs" onClick={() => {
              setFormData({personName:'', companyName:'', city:'', website:'', wechatId:'', mobileNumber:'', productCategory:'', catalogFile:null, distributorInterest:'', amazonSelling:'', authorizeImporterr:''});
              document.getElementById('catalogFileInput').value = ""; 
            }}>Clear form / 清除表单</button>
          </div>
        </form>

        {/* Contact Info Bar */}
        <div className="contact-info-bar-cs">
          <span><SlLocationPin /> importerr.com</span>
          <span><GoMail /> sellers@importerr.com</span>
          <span><IoCallOutline /> +91 98765 43210</span>
        </div>

      </div>
    </div>
  );
};

export default RegistrationFormCS;